import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { AxiosInstance } from 'axios';
import {
  CreateStaticDataTypeLabelPayload,
  UpdateStaticDataTypeLabelPayload,
} from '../staticDataTypeLabel/staticDataTypeLabel.types';
import {
  CreateStaticDataTypePayload,
  DeleteStaticDataTypePayload,
  UpdateStaticDataTypePayload,
} from './staticDataType.types';

const createStaticDataType = (client: AxiosInstance) => async (payload: CreateStaticDataTypePayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.CREATE_STATIC_DATA_TYPE, payload)).data;
};

const updateStaticDataType = (client: AxiosInstance) => async (payload: UpdateStaticDataTypePayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.UPDATE_STATIC_DATA_TYPE, payload)).data;
};

const deleteStaticDataType = (client: AxiosInstance) => async (payload: DeleteStaticDataTypePayload) => {
  return (
    await client.delete<{ message: string; data: unknown }>(API_ROUTES.DELETE_STATIC_DATA_TYPE, {
      data: payload,
    })
  ).data;
};

const createStaticDataTypeLabel = (client: AxiosInstance) => async (payload: CreateStaticDataTypeLabelPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.CREATE_STATIC_DATA_TYPE_LABEL, payload)).data;
};

const updateStaticDataTypeLabel = (client: AxiosInstance) => async (payload: UpdateStaticDataTypeLabelPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.UPDATE_STATIC_DATA_TYPE_LABEL, payload)).data;
};

const deleteStaticDataTypeLabel = (client: AxiosInstance) => async (staticDataLabelId: string) => {
  return (
    await client.delete<{ message: string; data: unknown }>(API_ROUTES.DELETE_STATIC_DATA_TYPE_LABEL, {
      params: { staticDataLabelId },
    })
  ).data;
};

export const staticDataTypeMutations = {
  createStaticDataType,
  updateStaticDataType,
  deleteStaticDataType,
  createStaticDataTypeLabel,
  updateStaticDataTypeLabel,
  deleteStaticDataTypeLabel,
};
